const BINDING_KEY = 'labop.microsoft-login.binding';
const BINDING_PATTERN = /^[A-Za-z0-9_-]{43}$/;
const BINDING_LIFETIME_MS = 10 * 60 * 1000;

export function beginMicrosoftLogin(now = Date.now()) {
  const bytes = new Uint8Array(32);
  window.crypto.getRandomValues(bytes);
  const binding = btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  sessionStorage.setItem(BINDING_KEY, JSON.stringify({ binding, expiresAt: now + BINDING_LIFETIME_MS }));
  return binding;
}

export function consumeMicrosoftLoginBinding(binding, now = Date.now()) {
  try {
    const expected = JSON.parse(sessionStorage.getItem(BINDING_KEY));
    sessionStorage.removeItem(BINDING_KEY);
    return BINDING_PATTERN.test(binding || '') && binding === expected?.binding
      && Number.isFinite(expected.expiresAt) && expected.expiresAt > now && expected.expiresAt <= now + BINDING_LIFETIME_MS;
  } catch { return false; }
}
